"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COGNITO_DEVICE_KEYS = exports.DEVICE_NOT_EXIST_ERROR = exports.CognitoDeviceKey = void 0;
var CognitoDeviceKey;
(function (CognitoDeviceKey) {
    CognitoDeviceKey["DEVICE_KEY"] = ".deviceKey";
    CognitoDeviceKey["DEVICE_GROUP_KEY"] = ".deviceGroupKey";
    CognitoDeviceKey["RANDOM_PASSWORD_KEY"] = ".randomPasswordKey";
})(CognitoDeviceKey = exports.CognitoDeviceKey || (exports.CognitoDeviceKey = {}));
exports.DEVICE_NOT_EXIST_ERROR = 'Device does not exist.';
exports.COGNITO_DEVICE_KEYS = Object.values(CognitoDeviceKey);
